<prof-topnav-plain></prof-topnav-plain>

<div class="vertical-group">
  <h2>{{ 'TOS_VIEW.tos_and_privacy' | translate }}</h2>
</div>

<div class="center-content">
  <prof-tos-cards></prof-tos-cards>
</div>
